<template>
    <div class="global-network">
        <div class="global-network__inner">
            <div class="title-wrapper">
                <div class="title-wrapper__inner">
                    <div class="section-symbol"></div>
                    <p class="section-title is-lato">GLOBAL<br>NETWORK</p>
                    <p class="section-desc" v-html="$t('main.globalnetwork.desc')"></p>
                    <router-link to="/globalnetwork" class="link is-lato">MORE</router-link>
                </div>
                <p class="section-label is-lato">GLOBAL NETWORKS</p>
            </div>
            <div class="map-wrapper is-lato">
                <sequential-entrance delay="250" animation="countryIn">
                <router-link v-for="country in countrys"
                    :key="country.name"
                    :to="'/globalnetwork#' + country.name"
                    :class="['country', country.name]">
                    <p v-html="country.content"></p>
                </router-link>
                </sequential-entrance>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GlobalNetwork',
    data: function () {
        return {
            countrys: [
                {name: 'uk', content: 'UNITED<br>KINGDOM'},
                {name: 'de', content: 'GERMANY'},
                {name: 'kr', content: 'KOREA'},
                {name: 'jp', content: 'JAPAN'}
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/mixin.scss';
@import '@/assets/style/main.scss';
@keyframes country {
    0% {opacity: 0; transform: scale(0.3);}
    50% {opacity: 1; transform: scale(1);}
    100% {opacity: 0; transform: scale(1.3);}
}
@keyframes country-visible {
    0% {transform: translateY(-30px); opacity: 0;}
    100% {transform: translateY(0); opacity: 1;}
}
.countryIn {
    position: relative;
    animation: country-visible 1000ms;
}
@include over-desktop {
    .global-network {
        position: relative;
        height: 540px;
        background-size: cover;
        background-image: url(../../assets/image/main/global-background.png);
        background-position: center bottom;
        &::before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            z-index: 1;
            left: -295px;
            width: 50%;
            height: 100%;
            background: #000;
        }
        &::after {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 0;
            width: 100%;
            height: 100%;
            background: rgba($color: #30234d, $alpha: 0.25);
        }
        &__inner {
            position: relative;
            z-index: 2;
            width: 1200px;
            height: 100%;
            margin: 0 auto;

            .title-wrapper {
                position: absolute;
                top: 50%;
                left: 0;
                transform: translateY(-50%);

                .section-symbol {
                    background: url(../../assets/image/logo/box03.svg) no-repeat center;
                    background-size: 100% auto;
                }
                .section-title,
                .section-desc {
                    color: #fff
                }
                .section-title {
                    margin-top: 12px;
                }
                .section-desc {
                    margin-top: 18px;
                    opacity: 0.7;
                }
                .link {
                    display: inline-block;
                    margin-top: 30px;
                    color: #fff;
                    font-size: 16px;
                    line-height: 16px;
                    opacity: 0.7;

                    &::after {
                        content: '';
                        display: inline-block;
                        margin-left: 10px;
                        margin-bottom: 2px;
                        width: 6px;
                        height: 6px;
                        border: solid #fff;
                        border-width: 1px 1px 0 0;
                        transform: rotate(45deg);
                    }
                }
                .section-label {
                    position: absolute;
                    top: 160px;
                    left: 320px;
                    font-weight: 700;
                    font-size: 16px;
                    color: #9694a9;
                    letter-spacing: 13px;
                    white-space: nowrap;
                    transform: rotate(-90deg);
                    transform-origin: top left;
                    opacity: 0.2;

                    &::before {
                        content: '';
                        display: block;
                        position: absolute;
                        top: 50%;
                        left: -190px;
                        width: 170px;
                        height: 1px;
                        background: #9694a9;
                    }
                }
            }
            .map-wrapper {
                position: absolute;
                top: 50%;
                right: 0;
                width: 773px;
                height: 349px;
                background-image: url(../../assets/image/common/global-map.png);
                background-size: 100% auto;
                background-repeat: no-repeat;
                background-origin: center;
                transform: translateY(-50%);

                .country {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 90px;
                    height: 90px;
                    border-radius: 50%;

                    &::before {
                        content: '';
                        display: block;
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;
                        animation: country 1400ms infinite;
                    }

                    &.uk,
                    &.de,
                    &.jp {
                        background: rgba($color: #ea7a94, $alpha: 0.7);
                        &::before {
                            background: rgba($color: #ea7a94, $alpha: 0.7);
                        }
                    }
                    &.kr {
                        background: rgba($color: #8d73c2, $alpha: 0.7);
                        &::before {
                            background: rgba($color: #8d73c2, $alpha: 0.7);
                        }
                    }

                    p {
                        position: absolute;
                        top: 50%;
                        z-index: 1;
                        width: 100%;
                        color: #fff;
                        font-weight: 700;
                        font-size: 13px;
                        text-align: center;
                        transform: translateY(-50%);
                    }
                    &.uk {
                        top: 10%;
                        left: -3%;
                        z-index: 1;
                    }
                    &.de {
                        top: 22%;
                        left: 6%;
                    }
                    &.kr {
                        top: 33%;
                        left: 33%;
                        z-index: 1;
                    }
                    &.jp {
                        top: 28%;
                        left: 42%;
                    }
                }
            }
        }
    }
    .section03 > .global-network {
        &::before {
            opacity: 0;
            transform: translateX(-150px);
            transition: opacity 500ms, transform 500ms;
        }
        .title-wrapper__inner {
            opacity: 0;
            transform: translateY(-40px);
            transition: opacity 1000ms 500ms, transform 1000ms 500ms;
        }
        .map-wrapper .country {
            display: none;
        }
        .section-label {
            opacity: 0;
            transform: rotate(-90deg) translateX(100px);
            transition: opacity 1000ms 750ms, transform 1000ms 750ms;
        }
        @include over-desktop {
            .map-wrapper {
                opacity: 0;
                transform: translate(0, -40%);
                transition: opacity 1000ms 250ms, transform 1000ms 250ms;
            }
        }
    }
    .section03.is-active > .global-network {
        &::before {
            opacity: 0.3;
            transform: translateX(0);
        }
        .title-wrapper__inner {
            opacity: 1;
            transform: translateY(0);
        }
        .map-wrapper .country {
            display: block;
        }
        .section-label {
            opacity: 0.2;
            transform: rotate(-90deg) translateX(0);
        }
        @include over-desktop {
            .map-wrapper {
                opacity: 1;
                transform: translate(0, -50%);
            }
        }
    }
}
@include desktop-small {
    .global-network {
        &::before {
            left: -170px;
        }
        &__inner {
            width: 1024px;
            .title-wrapper {
                left: 28px;
            }
            .map-wrapper {
                right: 28px;
                width: 600px;
                height: 274px;
                .country {
                    &.uk {
                        top: 10%;
                        left: -3%;
                    }
                    &.de {
                        top: 22%;
                        left: 8%;
                    }
                    &.kr {
                        top: 33%;
                        left: 33%;
                        z-index: 1;
                    }
                    &.jp {
                        top: 26%;
                        left: 44%;
                    }
                }
            }
        }
    }
}
@include under-tablet {
    .global-network {
        position: relative;
        padding: 0 28px 14vw;
        background-size: cover;
        background-image: url(../../assets/image/main/global-background-m.png);
        background-position: center bottom;
        &::before {
            display: none;
        }
        &::after {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 0;
            width: 100%;
            height: 100%;
            background: rgba($color: #30234d, $alpha: 0.25);
        }
        &__inner {
            position: relative;
            z-index: 1;
            .title-wrapper {
                width: calc(100% + 56px);
                margin-left: -28px;
                padding: 14vw 0;
                background: rgba($color: #000000, $alpha: 0.3);
                .section-label {
                    display: none;
                }
                .section-symbol {
                    background: url(../../assets/image/logo/box03.svg) no-repeat center;
                    background-size: 100% auto;
                }
                .section-title {
                    color: #fff;
                    margin-top: 3.4vw;
                }
                .section-desc {
                    margin-top: 3.4vw;
                    color: #fff;
                    opacity: 0.7;
                }
                .link {
                    color: #fff;
                    display: block;
                    margin-top: 3.4vw;
                    font-size: 3.4vw;
                    line-height: 5.8vw;
                    text-align: center;
                    &::after {
                        content: '';
                        display: inline-block;
                        margin-left: 8px;
                        margin-bottom: 2px;
                        width: 6px;
                        height: 6px;
                        border: solid #fff;
                        border-width: 1px 1px 0 0;
                        transform: rotate(45deg);
                    }
                }
            }
            .map-wrapper {
                position: relative;
                height: 50vw;
                margin-top: 14vw;
                background: url(../../assets/image/common/global-map.png) no-repeat center center;
                background-size: 100% auto;

                .country {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 18vw;
                    height: 18vw;
                    border-radius: 50%;

                    &::before {
                        content: '';
                        display: block;
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;
                        animation: country 1400ms infinite;
                    }

                    &.uk,
                    &.de,
                    &.jp {
                        background: rgba($color: #ea7a94, $alpha: 0.7);
                        &::before {
                            background: rgba($color: #ea7a94, $alpha: 0.7);
                        }
                    }
                    &.kr {
                        background: rgba($color: #8d73c2, $alpha: 0.7);
                        &::before {
                            background: rgba($color: #8d73c2, $alpha: 0.7);
                        }
                    }

                    p {
                        position: absolute;
                        top: 50%;
                        z-index: 1;
                        width: 100%;
                        color: #fff;
                        font-weight: 700;
                        font-size: 2.8vw;
                        text-align: center;
                        transform: translateY(-50%);
                    }
                    &.uk {
                        top: 8%;
                        left: -3%;
                        z-index: 1;
                    }
                    &.de {
                        top: 28%;
                        left: 9%;
                    }
                    &.kr {
                        top: 37%;
                        left: 33%;
                        z-index: 1;
                    }
                    &.jp {
                        top: 22%;
                        left: 46%;
                    }
                }
            }
        }
    }
    .section03 > .global-network {
        opacity: 0;
        transition: opacity 500ms;
        .title-wrapper {
            opacity: 0;
            transform: translateY(2vh);
            transition: opacity 500ms 300ms, transform 500ms 300ms;
        }
        .map-wrapper {
            opacity: 0;
            transform: translateY(2vh);
            transition: opacity 500ms 500ms, transform 500ms 500ms;
        }
        .map-wrapper .country {
            display: none;
        }
    }
    .section03.is-active > .global-network {
        opacity: 1;
        .title-wrapper {
            opacity: 1;
            transform: translateY(0);
        }
        .map-wrapper .country {
            display: block;
        }
        .map-wrapper {
            opacity: 1;
            transform: translateY(0);
        }
    }
}
@include mobile {
    .global-network {
        padding: 0 20px 14vw;
        &__inner {
            .title-wrapper {
                width: calc(100% + 40px);
                margin-left: -20px;

                .link {
                    font-size: 4vw;
                    line-height: 6vw;
                }
            }
            .map-wrapper {
                .country {
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/main/GlobalNetwork.vue